import { _enum, boolean, schema } from "@anna-money/anna-web-lib/serializer";

// Mirrors the backend KybCallStatus: where the customer is in the *call step*, not the compliance
// verdict. The pass/fail decision is the FORMATIONS_PRECHECK risk review, which blocks the filing
// server-side (PreSendCheckerService) — the customer is told about it out of band, not here.
export enum ComplianceCallStatus {
  NotStarted = "NOT_STARTED",
  InProgress = "IN_PROGRESS",
  // The call happened and the transcript came back — move on to waiting for the compliance check.
  Completed = "COMPLETED",
  // The call could not be completed (placement failed, or the call itself was unsuccessful) — the
  // customer can request another one, with no limit on attempts.
  Failed = "FAILED",
  // Backend marks superseded calls OBSOLETE on a re-request. GET returns the latest row so this
  // shouldn't normally surface, but it's in the contract — kept here so deserialization never throws.
  // Non-terminal → the UI falls back to the request screen.
  Obsolete = "OBSOLETE",
}

const COMPLIANCE_CALL_TERMINAL_STATUSES: ComplianceCallStatus[] = [
  ComplianceCallStatus.Completed,
  ComplianceCallStatus.Failed,
];

export const isTerminalComplianceCallStatus = (status: ComplianceCallStatus): boolean =>
  COMPLIANCE_CALL_TERMINAL_STATUSES.includes(status);

export class ComplianceCallData extends schema(
  {
    status: _enum(ComplianceCallStatus, "ComplianceCallStatus"),
    // Whether this customer needs the call at all (e.g. false for a non-GB mobile, or a manual
    // support skip). `skip_reason` also comes back when this is false, but nothing on the frontend
    // needs to know why, so it isn't declared here.
    isRequired: boolean(),
  },
  "ComplianceCallData",
) {}
